import types from "./types";

const updateErrorTab = (payload) => {
  return {type: types.UPDATE_ERROR_TAB, payload}
};

export default {
  updateErrorTab
};
